<template>

<div >

<div>

   <template>
<div>
   <iframe  style="width:100%;height:500px" :src="this.url"  title="W3Schools Free Online Web Tutorials"></iframe>
</div>
    </template>
 <div>
 <v-card-actions>
                <v-btn color="primary" @click="voltar()">Voltar</v-btn>
              </v-card-actions>

    </div>

    </div>
  </div>
</template>

<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
import impressaoService from '../../services/impressaoService';
import impressaoUtilitario from '../../utilitarios/impressao.utilitario';
export default {
  data: () => ({
    config: '',
    baseUrl: '',
    url: '',
    html: '',
    empresa: {
      'nome_empresa': 'Colégio Bendizer',
      'localidade': 'Vila-Alice',
      'zona': 'Rangel',
      'provincia': 'Luanda',
      'telefone': '999207671',
      'email': 'ColegioBendizer@gmail.co.ao',
      'detalhes': 'Matric. Conservatória do Registo Comercial de Luanda',
      'contribuente': '5480006576',
      'NIF': '2401268340',
  
    },
    turma:  {
      descricao: ls.get('turma').descricao,
      classe: ls.get('turma').classe,
      curso: ls.get('turma').curso,
      anolectivo: ls.get('turma').anolectivo
    },
    devedores: ls.get('estudantes_'),
    // devedores: [
    //   {
    //     'nome': 'Mário Carlos',
    //     'matricula': '665557',
    //     'mes': 'Janeiro,Fevereiro,Março,Abril',
    //     'divida': '20000'
    //   }
    // ],    
    formatter: 0,
    date: null
  }),
  created () {
    this.config = impressaoUtilitario.getConfig();
    this.getUrlImpressao();
  },

  methods: {
    async getUrlImpressao() {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        console.log(error);
      } finally {
        this.html_pdf()
      }
    }, 

    voltar (){  this.$router.push('mensalidades-pagas') },
      
    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    // Enviando a maior quantidade de linhas das tabelas (Items, Modo de Pagamento, Resumo de Imposto)
   
    html_pdf(){
      this.date = this.correntDate()
      let dados= ``
      let i = 1
       
      this.devedores.forEach(element => {
        dados += `<tr>
    <td valign="top" style="text-align:justify;font-size:8px;">` + i + `</td>
    <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome  + `</td>
     <td valign="top" style="text-align:justify;font-size:8px;" >` + element.idMatricula  + `</td>
    <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + (element.meses === undefined ? "" : element.meses) + `]</td>
     <td valign="top" style="text-align:right;padding-right:10px;font-size:8px;">` + (element.multas === undefined ? "" : element.multas) + `</td>
    </tr>`
        i++       
      })

        this.html = `
       <html>
<head>
<style>
table, th, td {
  border: 0px solid black;
  border-collapse: collapse;
  font-size: 11px;
}

#rcorners2 {
   border-radius: 25px;
  border: 1px solid #000000;
  padding: 20px; 
  width: 250px;
  height: 40px;
}
.column {
  float: left;
  width: 70.33%;
  padding: 5px;
}
.footer {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
}
</style>
</head>
<body>

 <table style="border:0px solid black;margin-left:0px;margin-right:auto;width:100%">
    <tr>
        <td>
            <div class="column">
    <span>  <img src="${this.baseUrl}readfile/`+this.config.logo+`" alt="Snow" style="width:50%; max-width:80px;" /></span>
  </div>
        </td>
         <td> 
          <strong style=" font-size:15px;">`+ this.config.descricao +`</strong>
        </td>
         
    </tr>
       </table>
       <div style="text-align:center;padding:5px;"><strong style=" font-size:10px">  Lista de estudantes com propinas pagas da turma: `+this.turma.descricao+`</strong> </div>
          <div id="rcorners2">
          <span style="font-size:10px">Ano académico: `+this.turma.classe+`º</span>
          <br><span style="font-size:10px">Curso: `+this.turma.curso+`</span>
          <br><span style="font-size:10px">Ano Lectivo: `+this.turma.anolectivo+`</span>
        </div>
   
<table style="width:100%;margin-top:30px">
  <tr>
  <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">Ord.</th>
  <th bgcolor="#DCDCDC" style="text-align:justify;font-size:8px;padding-top:10px;padding-bottom:10px;width:200px!important">Nome</th>
  <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size:8px">Matricula</th>                      
  <th bgcolor="#DCDCDC" style="text-align:center;padding-top:10px;padding-bottom:10px;font-size:8px;width:150px!important">Meses</th>                     
  <th bgcolor="#DCDCDC" style="text-align:right;padding-top:10px;padding-bottom:10px;font-size:8px;padding-right:10px">Valor Pago</th>
  </tr>

  `+dados+`

<tr>
<th colspan="4" style="text-align:right" bgcolor="#DCDCDC">Total dívida</th>
    <td  style="text-align:right" bgcolor="#DCDCDC">` + this.formatMoney(ls.get('total')) + `</td>
</tr>

</table>
<div class="footer"> <center style="font-size:8px;margin-top:8px">Luanda, ` + this.date + `</center> </div>
<div style="margin-top:990px">

</body>
</html>`

let options = { 
  'format': 'A4',
  'border': {'right': '12mm', 'left': '12mm'},
  'header': {'height': '15mm' },
  'footer': {'height': '12mm'}
}
impressaoService.htmlToPdf(this.html, options);
    },

    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
    }
  }

}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
